/**
 * 项目管理
 */
const FinancialRouter = {
  path: '/financial',
  component: () => import('@/views/layout'),
  redirect: '/financial/wages/list',
  alwaysShow: true,
  meta: {
    title: '财务管理',
    icon: require('@/assets/slider/financial.png')
  },
  children: [
    {
      path: 'wages/list',
      name: 'wages_manage',
      component: () => import('@/views/financial_manage/wages_manage'),
      meta: {
        title: '工资',
        keepAlive: true
      }
    },
    {
      path: 'service/list',
      redirect: '/service/list',
      component: () => import('@/views/financial_manage/service_charge'),
      alwaysShow: true,
      meta: {
        title: '服务费管理'
      }
    },
    {
      path: 'approval/list',
      component: () => import('@/views/financial_manage/financial_approval'),
      alwaysShow: true,
      meta: {
        title: '财务审批'
      }
    }

    // {
    //   path: 'approval',
    //   redirect: '/approval/list',
    //   component: () => import('@/views/financial_manage/financial_approval'),
    //   alwaysShow: true,
    //   meta: {
    //     title: '财务审批'
    //   },
    //   children: [
    //     {
    //       path: 'approval/list',
    //       name: 'financial_approval',
    //       component: () => import('@/views/financial_manage/financial_approval/pages/requestfunds'),
    //       meta: {
    //         title: '请款'
    //       }
    //     },
    //     {
    //       path: 'wiped/list',
    //       name: 'reimbursement',
    //       component: () => import('@/views/financial_manage/financial_approval/pages/reimbursement'),
    //       meta: {
    //         title: '报销'
    //       }
    //     }

    //   ]
    // }
  ]
}

const FinancialDescRouter = {
  path: '/financial',
  component: () => import('@/views/layout'),
  hidden: true,
  meta: {
    title: 'desc'
  },
  children: [
    {
      path: 'wages/company/:id',
      name: 'wages_company',
      hidden: true,
      component: () => import('@/views/financial_manage/wages_manage/salary_setting/setting_company'),
      meta: {
        title: '公司工资设定'
      }
    },
    {
      path: 'wages/project/:id',
      name: 'wages_project',
      hidden: true,
      component: () => import('@/views/financial_manage/wages_manage/salary_setting/setting_project'),
      meta: {
        title: '项目工资设定'
      }
    },
    {
      path: 'wages/edit/:id',
      name: 'wages_staff',
      hidden: true,
      component: () => import('@/views/financial_manage/wages_manage/salary_setting/setting_staff'),
      meta: {
        title: '编辑'
      }
    },
    {
      path: 'wages/submit',
      name: 'wages_submit_sure',
      hidden: true,
      component: () => import('@/views/financial_manage/wages_manage/salary_setting/submit_sure'),
      meta: {
        title: '提交确认'
      }
    },
    {
      path: 'wages/salary/desc/:id',
      name: 'salary_desc',
      hidden: true,
      component: () => import('@/views/financial_manage/wages_manage/salary_approval/desc'),
      meta: {
        title: '详情'
      }
    },
    {
      path: 'wages/setting/:id',
      name: 'wage_setting',
      hidden: true,
      component: () => import('@/views/financial_manage/wages_manage/salary_setting/wage_setting'),
      meta: {
        title: '工资设定'
      }
    },
    {
      path: 'wages/history/company/setting/:id',
      name: 'history_company_setting',
      hidden: true,
      component: () => import('@/views/financial_manage/wages_manage/salary_setting/historical_setting/company_setting'),
      meta: {
        title: '查看历史公司工资标准设定'
      }
    },
    {
      path: 'wages/history/project/setting/:id',
      name: 'history_project_setting',
      hidden: true,
      component: () => import('@/views/financial_manage/wages_manage/salary_setting/historical_setting/project_setting'),
      meta: {
        title: '查看历史项目工资标准设定'
      }
    },
    {
      path: 'wages/edit/project/setting/:id',
      name: 'edit_project_setting',
      hidden: true,
      component: () => import('@/views/financial_manage/wages_manage/salary_setting/edit_setting/edit_project'),
      meta: {
        title: '编辑项目'
      }
    },
    {
      path: 'wages/edit/staff/setting/:id',
      name: 'edit_staff_setting',
      hidden: true,
      component: () => import('@/views/financial_manage/wages_manage/salary_setting/edit_setting/edit_staff'),
      meta: {
        title: '编辑个人'
      }
    }
  ]
}
export { FinancialRouter, FinancialDescRouter }
